import Navbar from "./Navbar";
import Footer from "./Footer";
import {Outlet} from "react-router-dom";

function Base() {
  return (
    <div>
      <Navbar />
      <main>
        <Outlet/>
      </main>
      <Footer />
    </div>
  );
}

export default Base;
